import { Box, Typography } from '@mui/material'
import { get } from 'lodash'
import { useEffect, useState } from 'react'

import { useSnackbar } from 'notistack'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { color } from 'config/color'

import { MButton } from 'components'
import { ROUTES_PATH, isFeatureActive } from 'config'
import { useAuth } from 'context'
import { isAuthorized, useMobileBreakpoints } from 'utils'
import {
  AccountDetails,
  AccountProfile,
  EmailVerification,
  InvoiceCloud,
  LinkedAccounts,
  PhoneNumber
} from '.'
import { CognitoDetails } from './CognitoDetails'
const isCognitoEnabled = isFeatureActive('cognito')
export const Account = (): JSX.Element => {
  const [searchParams] = useSearchParams()
  const email = searchParams.get('email') ?? ''
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const isInvoiceCloudEnabled = isFeatureActive('ic_enabled')
  const [linkedAccountsRefreshKey, setLinkedAccountsRefreshKey] = useState(0)

  const { account, getUser, handleLogOut } = useAuth()

  const isMobile = useMobileBreakpoints()

  const refreshLinkedAccounts = (): void => {
    setLinkedAccountsRefreshKey(prev => prev + 1)
  }

  const getUserData = async (): Promise<void> => {
    if (email !== account?.ccsEmail) {
      try {
        await getUser('', email)
      } catch (error) {
        if (!isAuthorized(error)) await handleLogOut()
        const message = get(error, 'response.data.error', 'something went wrong.')
        enqueueSnackbar(message, { variant: 'error' })

        navigate(ROUTES_PATH.ACCOUNT_MANAGER)
      }
    }
  }

  useEffect(() => {
    void getUserData()
  }, [email])

  return (
    <Box mt={5} bgcolor={color.white}>
      <Box
        display="flex"
        p={3}
        gap={1}
        flexDirection={isMobile ? 'column' : 'row'}
        justifyContent="space-between"
        borderBottom={`solid 1px ${color.secondary.dark[200]}`}
      >
        <Typography color={color.grey[900]} fontWeight={400} fontSize={24}>
          Customer Search Result
        </Typography>

        <MButton
          variant="contained"
          component="label"
          type="button"
          rounded="true"
          sx={{ fontSize: 16 }}
          texttransform="none"
          onClick={() => {
            navigate(ROUTES_PATH.ACCOUNT_MANAGER)
          }}
        >
          <Typography color={color.white} fontWeight={300} fontSize={16}>
            Go back to Search
          </Typography>
        </MButton>
      </Box>

      <Box
        display="flex"
        flexDirection={isMobile ? 'column' : 'row'}
        gap={2}
        p={2}
      >
        <Box width={isMobile ? '100%' : '25%'}>
          <AccountProfile onLinkedAccountsChange={refreshLinkedAccounts} />
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          width={isMobile ? '100%' : '75%'}
          gap={2}
        >
          <AccountDetails />

          {isInvoiceCloudEnabled && (
            <>
              <InvoiceCloud />
              <PhoneNumber />
            </>
          )}
          <LinkedAccounts refreshKey={linkedAccountsRefreshKey} />
          <EmailVerification />
          {isCognitoEnabled && <CognitoDetails getUserData={getUserData} />}
        </Box>
      </Box>
    </Box>
  )
}
